import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DoughnutChart from "components/common/Charts/DoughnutChart";
import {
  doughnutChartCommonOptions,
  reviewDashboardChart,
} from "components/constants/ChartConstant";

const PositiveNegativeRatings = ({ ratingDashboardDetails }) => {
  const { t } = useTranslation();
  const { positiveNegativeChart } = reviewDashboardChart;

  const [data, setData] = useState({
    labels: ["Positive", "Negative"],
    datasets: [
      {
        data: [],
        ...positiveNegativeChart,
      },
    ],
  });

  useEffect(() => {
    if (ratingDashboardDetails?.pieChart) {
      const { positive, negative } = ratingDashboardDetails?.pieChart || {};
      setData((prev) => ({
        ...prev,
        datasets: [
          {
            ...prev.datasets[0],
            data: [positive, negative],
          },
        ],
      }));
    }
  }, [ratingDashboardDetails]);

  return (
    <div className="common_col positive_neg_ratings w-50">
      <h2 className="fs_20">{t("Positive & Negative Ratings")}</h2>
      <h3 className="total_ratings_text">{t("Total Ratings")}</h3>
      <h4 className="fs_14 mt-2">{ratingDashboardDetails?.pieChart?.total}</h4>
      <div className="chart d-flex justify-content-center align-items-end gap-4">
        {/* Positive Section */}
        <div className="text-center me-4">
          <div className="d-flex align-items-center gap-1 justify-content-center mb-1">
            <span
              className="rounded-circle"
              style={{
                width: 10,
                height: 10,
                backgroundColor: data.datasets[0].backgroundColor[0],
              }}
            ></span>
            <span className="text-muted fs_12">{t("Positive")}</span>
          </div>
          <p className="fs_12 mt-4">
            {ratingDashboardDetails?.pieChart?.positivePercentage}%
          </p>
        </div>
        <div >
          <DoughnutChart
            data={data}
            options={{
              ...doughnutChartCommonOptions,
              plugins: {
                ...doughnutChartCommonOptions.plugins,
                legend: {
                  ...doughnutChartCommonOptions.plugins.legend,
                  display: false, // 👈 hide legend only here
                },
              },
            }}
            width={200}
            height={200}
          />
        </div>

        {/* Negative Section */}
        <div className="text-center ms-4">
          <div className="d-flex align-items-center gap-1 justify-content-center mb-1">
            <span
              className="rounded-circle"
              style={{
                width: 10,
                height: 10,
                backgroundColor: data.datasets[0].backgroundColor[1],
              }}
            ></span>
            <span className="text-muted fs_12">{t("Negative")}</span>
          </div>
          <p className="fs_12 mt-4">
            {ratingDashboardDetails?.pieChart?.negativePercentage}%
          </p>
        </div>
      </div>
    </div>
  );
};

export default PositiveNegativeRatings;
